import { render } from "./L.vue?vue&type=template&id=be15f6c8"
import script from "./L.vue?vue&type=script&lang=js"
export * from "./L.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__